export const BookingDetailsCode = {
  body: {
    bookingId: "D0624-2192",
  },

  response: {
    bookingDetails: {
      source: {
        placename: "London Heathrow Airport (LHR), Hounslow, UK,undefined",
        lat: "51.4679914",
        lng: "-0.455051",
      },
      priceDetails: {
        amount: 500,
        currency: "SAR",
      },
      _id: "66ae11f9a495b07d39755653",
      bookingType: "HOURLY",
      bookingId: "D0824-2262",
      bookingStatus: "CONFIRMED",
    },
  },
};


export const BookingDetailsCodeImplementation = {
    nodejs_Axios: `
  const axios = require('axios');
  let data = JSON.stringify({
    "bookingId": "D0824-2262"
  });
  
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://testapi.drivado.com/api/v1/api/apibookingStatus?email=W1user1@email.com',
    headers: { 
      'apikey': 'mvDxL3NxHMZCPzqx7Ce0DWEvBmYLa7', 
      'Content-Type': 'application/json'
    },
    data: data
  };
  
  axios.request(config)
  .then((response) => {
    console.log(JSON.stringify(response.data));
  })
  .catch((error) => {
    console.log(error);
  });
  `,
    python: `
  import requests
  import json
  
  url = "https://testapi.drivado.com/api/v1/api/apibookingStatus?email=W1user1@email.com"
  
  payload = json.dumps({
    "bookingId": "D0824-2262"
  })
  headers = {
    'apikey': 'mvDxL3NxHMZCPzqx7Ce0DWEvBmYLa7',
    'Content-Type': 'application/json'
  }
  
  response = requests.request("GET", url, headers=headers, data=payload)
  
  print(response.text)
  `,
    go: `
  package main
  
  import (
    "bytes"
    "encoding/json"
    "fmt"
    "net/http"
  )
  
  func main() {
    url := "https://testapi.drivado.com/api/v1/api/apibookingStatus?email=W1user1@email.com"
  
    payload := map[string]string{
      "bookingId": "D0824-2262"
    }
    jsonData, _ := json.Marshal(payload)
  
    req, _ := http.NewRequest("GET", url, bytes.NewBuffer(jsonData))
    req.Header.Set("apikey", "mvDxL3NxHMZCPzqx7Ce0DWEvBmYLa7")
    req.Header.Set("Content-Type", "application/json")
  
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
  
    var result map[string]interface{}
    json.NewDecoder(resp.Body).Decode(&result)
  
    fmt.Println(result)
  }
  `,
    curl: `
  curl --location --request GET 'https://testapi.drivado.com/api/v1/api/apibookingStatus?email=W1user1@email.com' \\
  --header 'apikey: mvDxL3NxHMZCPzqx7Ce0DWEvBmYLa7' \\
  --header 'Content-Type: application/json' \\
  --data-raw '{
    "bookingId": "D0824-2262"
  }'
  `,
    php: `
  <?php
  
  $curl = curl_init();
  
  $data = json_encode(array(
    "bookingId" => "D0824-2262"
  ));
  
  curl_setopt_array($curl, array(
    CURLOPT_URL => 'https://testapi.drivado.com/api/v1/api/apibookingStatus?email=W1user1@email.com',
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_ENCODING => '',
    CURLOPT_MAXREDIRS => 10,
    CURLOPT_TIMEOUT => 0,
    CURLOPT_FOLLOWLOCATION => true,
    CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
    CURLOPT_CUSTOMREQUEST => 'GET',
    CURLOPT_POSTFIELDS => $data,
    CURLOPT_HTTPHEADER => array(
      'apikey: mvDxL3NxHMZCPzqx7Ce0DWEvBmYLa7',
      'Content-Type: application/json'
    ),
  ));
  
  $response = curl_exec($curl);
  
  curl_close($curl);
  echo $response;
  ?>
  `
  };